<template>
<div class="vxBG">
    <b-container>
        <button v-if="!isMobile()" @click="oldHome()" class="navButton">HOME PAGE</button>
        <button v-if="isMobile()" @click="oldHome()" class="navButton mobileNav">HOME PAGE</button>
    </b-container>
    
</div>
</template>

<script>
import bluewalkgif from '../../assets/VX/bluewalk.gif'
import bluewalkpng from '../../assets/VX/bluewalk.png'

import tier2gif from '../../assets/VX/tier2.gif'
import tier2png from '../../assets/VX/tier2.png'


export default {
    mounted()
    {
        $('#vxModel')
            .mouseenter(function(){$('#vxModel').attr('src', bluewalkgif);})
            .mouseleave(function(){$('#vxModel').attr('src', bluewalkpng);});

        $('#vxModelSword')
            .mouseenter(function(){$('#vxModelSword').attr('src', tier2gif);})
            .mouseleave(function(){$('#vxModelSword').attr('src', tier2png);});

        $('#vxModelMount')
            .mouseenter(function(){$('#vxModelMount').attr('src', tier2gif);})
            .mouseleave(function(){$('#vxModelMount').attr('src', tier2png);});
    },
    methods:{
      oldHome()
      {
        this.$router.push({ name: 'oldHome' })
      },
      isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
     }

        
}
</script>

<style scoped>
.colStart
{
    margin-top: 22vh;
}

.logo
{
    margin: auto;
    width: 25vh;
}
.vxBG
{
    background: url("../../assets/VX/CosmicCity.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    height: 100vh;
}

.vxModelMount
{
    margin: auto;
    display: inline-block;
    width: 40vh;
    margin-top: 5vh;
    margin-right: 3vh;
    margin-left: 3vh;
}
.vxModelSword
{
    margin: auto;
    display: inline-block;
    width: 50vh;
    margin-top: 5vh;
    margin-right: 3vh;
    margin-left: 3vh;
}
.vxModel
{
    margin: auto;
    width: 20vh;
    margin-top: 5vh;
    display: inline-block;
    margin-right: 2vh;
    margin-left: 2vh;
}

.navButton
{
  color: white;
  position: absolute;
  font-size: 2vh;
  left: 5%;
  top: 5%;
}
.mobileNav
{
  top: 15% !important;
  left: 30%;
}

.navButton {
  background-color: white;
  border: 0 solid #e2e8f0;
  border-radius: 1.5rem;
  box-sizing: border-box;
  color: black;
  cursor: pointer;
  display: inline-block;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1;
  padding: 1rem 1.6rem;
  text-align: center;
  text-decoration: none #0d172a solid;
  text-decoration-thickness: auto;
  transition: all .1s cubic-bezier(.4, 0, .2, 1);
  box-shadow: 0px 1px 2px rgba(166, 175, 195, 0.25);
}

.navButton:hover {
  background-color: #d343e5;
  color: black;
}

.navButton:hover,
.navButton:focus {
  box-shadow: 0 0.5em 0.5em -0.4em white;
  transform: translateY(-0.25em);
}

@media (min-width: 768px) {
  .navButton {
    font-size: 1.125rem;
    padding: 1rem 2rem;
  }
}

.chevron {
  position: absolute;
  width: 28px;
  height: 8px;
  left: 50%;
  top: 90%;
  opacity: 0;
  transform: scale3d(0.5, 0.5, 0.5);
  animation: move 3s ease-out infinite;
}

.chevron:first-child {
  animation: move 3s ease-out 1s infinite;
}

.chevron:nth-child(2) {
  animation: move 3s ease-out 2s infinite;
}

.chevron:before,
.chevron:after {
  content: ' ';
  position: absolute;
  top: 0;
  height: 100%;
  width: 51%;
  left: 50%;
  background: #fff;
}

.chevron:before {
  left: 0;
  transform: skew(0deg, 30deg);
}

.chevron:after {
  right: 0;
  width: 50%;
  transform: skew(0deg, -30deg);
}

@keyframes move {
  25% {
    opacity: 1;

  }
  33% {
    opacity: 1;
    transform: translateY(30px);
  }
  67% {
    opacity: 1;
    transform: translateY(40px);
  }
  100% {
    opacity: 0;
    transform: translateY(55px) scale3d(0.5, 0.5, 0.5);
  }
}


</style>


// WEBPACK FOOTER //
// src/components/Vx/Heading.vue